var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PageCheckBox"},[_c('div',{staticClass:"content"},[_c('span',[_vm._v("导图中图片是否点击弹出大图")]),_c('a-switch',{attrs:{"defaultChecked":""},on:{"change":_vm.onChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }